import { useTranslation } from 'react-i18next';

import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import * as S from 'pages/Home/OnboardingV2/Onboarding.styled.jsx';

import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

const SupportCards = () => {
	const { t } = useTranslation();
	const supportCartsConfig = [
		{
			imageUrl: 'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/send-message.svg',
			title: 'sendMessage',
			description: 'sendMessageDescription',
			action: async () => {
				if (window.activeChatAgent) {
					window.fcWidget?.open();
				} else {
					await window.voiceflow?.chat.open();
					await window.voiceflow?.chat.show();
				}
			}
		},
		{
			imageUrl: 'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/book-date.svg',
			title: 'bookDate',
			description: 'bookDateDescription',
			action: () => window.open(t('v2BookAMeetingLink'), 'target:_blank')
		}
	];

	return (
		<S.HelpCardsWrapper>
			{supportCartsConfig.map((card) => (
				<HelpButton key={card.title} {...card} />
			))}
		</S.HelpCardsWrapper>
	);
};

export default SupportCards;

const HelpButton = ({ imageUrl, title, description, action }) => {
	const { t } = useTranslation();
	return (
		<S.HelpButton onClick={action}>
			<S.ImageWrapper className="image-wrapper">
				<Image url={imageUrl} width="3rem" height="3rem" />
			</S.ImageWrapper>
			<div>
				<Typography noWrap gutterBottom variant="caption" color="var(--content-3)" fontWeight="700">
					{t(title).toUpperCase()}
				</Typography>
				<Typography variant="p3" noWrap>
					{t(description)}
				</Typography>
			</div>

			<S.SupportCardButton className="nav-icon">
				<Icon icon={faChevronRight} size="small" />
			</S.SupportCardButton>
		</S.HelpButton>
	);
};
